export const utmParams = ['utm_source', 'utm_medium', 'utm_campaign']
